import config from '../config';

function imageurl(image, type) {
    const imagename = image.replace(/\//g, '_').replace(/\+/g, '-');
    const imagetype = type ? type : 'jpg';
    return `${config.imageserver}/${config.domain}/img/${imagename}.${imagetype}`;
}

export default imageurl;